import { jsx as _jsx } from "react/jsx-runtime";
import { CursorArrowIcon, HandIcon } from '@radix-ui/react-icons';
import { Button, Tooltip } from '@radix-ui/themes';
import { useTranslation } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';
export function SelectionTools() {
    const { t } = useTranslation();
    const { currentTool, setTool } = useEditorStore();
    const selectionTools = [
        { id: 'select', icon: _jsx(CursorArrowIcon, {}), titleKey: 'toolbar.tools.select' },
        { id: 'pan', icon: _jsx(HandIcon, {}), titleKey: 'toolbar.tools.pan' },
    ];
    return (_jsx("div", { className: "selection-tools", children: selectionTools.map((tool) => (_jsx(Tooltip, { content: t(tool.titleKey), children: _jsx(Button, { variant: "soft", radius: "none", size: "3", onClick: () => setTool(tool.id), className: currentTool === tool.id ? 'active' : '', children: tool.icon }) }, tool.id))) }));
}
